import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArchiveJunk: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArchiveJunk"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V9H21V21ZM12 13.7266L10.1367 11.8633L8.86328 13.1367L10.7266 15L8.86328 16.8633L10.1367 18.1367L12 16.2734L13.8633 18.1367L15.1367 16.8633L13.2734 15L15.1367 13.1367L13.8633 11.8633L12 13.7266Z" fill="currentColor"/><Path d="M22 7H2V3H22V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArchiveJunk;
